module.exports = __webpack_public_path__ + "static/media/poly-grid-right.560ea44f.svg";